import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    getDeliverabilityIndex: params =>
      `${baseURL}/api/deliverability?${encodeParams(params)}`
  }
})(process.env.BEACCOUNTDELIVERABILITY_URL)

export const beAccountDeliverabilityApiGetDeliverabilityIndex = async params => {
  const url = endpoints.getDeliverabilityIndex(params)
  
  return await apiWrapper({
    method: 'get',
    url
  }).then(res => res.data)
}
/**
 * @param {Object} params
 */
